import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	header: {
		id: 'gift.year.header2',
		defaultMessage: 'Gift a Calm Subscription',
		description: 'Header saying you can give a Calm subscription as a gift',
	},
	description: {
		id: 'gift.subscription.copy',
		defaultMessage: 'Make someone’s day by gifting them a subscription to Calm Premium.',
		description: 'Description saying you can give a Calm subscription as a gift',
	},
	buttonCta: {
		id: 'gift.subscription.yearButton',
		defaultMessage: 'Gift a Year',
		description: 'Button text to give an annual Calm subscription as a gift',
	},
	lifetimeButtonCta: {
		id: 'gift.subscription.lifetimeButton',
		defaultMessage: 'Gift a Lifetime',
		description: 'Button text to give a lifetime Calm subscription as a gift',
	},
});
